import * as yup from 'yup';

export const Resolucion_facturacionColumnList = (isAdmin) => {
   return [
      {
         id: 'resolucion_facturacion_id',
         dbname: 'id',
         label: 'id',
         visible: false,
         form: false,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'resolucion_facturacion_conjunto_id',
         dbname: 'conjunto_id',
         label: 'conjunto_id',
         visible: !!isAdmin,
         form: !!isAdmin,
         filter: !!isAdmin,
         foreign: {
            table: 'conjunto',
            label: 'conjunto',
            dbname: 'conjuntodesc',
            type: 'large'
         }
      },
      {
         id: 'resolucion_facturacion_numero_resolucion',
         dbname: 'numero_resolucion',
         label: 'numero_resolucion',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'resolucion_facturacion_descripcion',
         dbname: 'descripcion',
         label: 'descripcion',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'resolucion_facturacion_fecha_emision',
         dbname: 'fecha_emision',
         label: 'fecha_emision',
         visible: true,
         form: true,
         filter: true,
         type: 'datetime',
      },
      {
         id: 'resolucion_facturacion_fecha_vencimiento',
         dbname: 'fecha_vencimiento',
         label: 'fecha_vencimiento',
         visible: true,
         form: true,
         filter: true,
         type: 'datetime',
      },
      {
         id: 'resolucion_facturacion_prefijo',
         dbname: 'prefijo',
         label: 'prefijo',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'resolucion_facturacion_numero_inicial',
         dbname: 'numero_inicial',
         label: 'numero_inicial',
         visible: true,
         form: true,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'resolucion_facturacion_numero_final',
         dbname: 'numero_final',
         label: 'numero_final',
         visible: true,
         form: true,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'resolucion_facturacion_fecha_creacion',
         dbname: 'fecha_creacion',
         label: 'fecha_creacion',
         visible: true,
         form: false,
         filter: false,
         type: 'datetime',
      },
      {
         id: 'resolucion_facturacion_fecha_actualizacion',
         dbname: 'fecha_actualizacion',
         label: 'fecha_actualizacion',
         visible: false,
         form: false,
         filter: false,
         type: 'datetime',
      },
      {
         id: 'resolucion_facturacion_activo',
         dbname: 'activo',
         label: 'activo',
         visible: true,
         form: true,
         filter: true,
         type: 'boolean',
      },

   ];
};

export const Resolucion_facturacionValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      conjunto_id: yup.number().nullable(),
      numero_resolucion: yup.string().nullable(),
      descripcion: yup.string().nullable(),
      fecha_emision: yup.date().nullable(),
      fecha_vencimiento: yup.date().nullable(),
      prefijo: yup.string().nullable(),
      numero_inicial: yup.number().nullable(),
      numero_final: yup.number().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_actualizacion: yup.date().nullable(),
      activo: yup.boolean().nullable(),

   });
};

export const Resolucion_facturacionFilterValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      conjunto_id: yup.number().nullable(),
      numero_resolucion: yup.string().nullable(),
      descripcion: yup.string().nullable(),
      fecha_emision: yup.date().nullable(),
      fecha_vencimiento: yup.date().nullable(),
      prefijo: yup.string().nullable(),
      numero_inicial: yup.number().nullable(),
      numero_final: yup.number().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_actualizacion: yup.date().nullable(),
      activo: yup.boolean().nullable(),

   });
};